import { Coffee, Truck, ArrowRight, Zap } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useState } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

// Replace with the real Stripe link when ready
const STRIPE_LINK = 'https://buy.stripe.com/00w8wQ0vd3KL0Bvdo63VC0o';

export default function KiltedAndCaffeinated() {
  const [showOrderModal, setShowOrderModal] = useState(false);

  return (
    <div className="min-h-screen bg-[#132947]">
      <Header />

      {/* Hero */}
      <div className="relative min-h-screen overflow-hidden">
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage:
              'url(https://images.unsplash.com/photo-1508098682722-e99c43a406b2?w=1920&q=80)',
          }}
        >
          <div className="absolute inset-0 bg-gradient-to-b from-[#0d1f3c]/90 via-[#132947]/92 to-[#132947]" />
        </div>

        {/* Scottish blue glow accents */}
        <div className="absolute top-20 right-10 w-96 h-96 bg-blue-700/20 rounded-full blur-3xl animate-pulse" />
        <div className="absolute bottom-20 left-10 w-80 h-80 bg-amber-500/10 rounded-full blur-3xl" />

        <div className="relative min-h-screen flex items-center justify-center px-6 max-w-7xl mx-auto py-20">
          <div className="grid lg:grid-cols-2 gap-16 items-center w-full">
            {/* Left: copy */}
            <div className="text-center lg:text-left space-y-6 order-2 lg:order-1">
              <div className="inline-flex items-center gap-2 bg-amber-500/15 border border-amber-400/30 text-amber-300 px-5 py-2 rounded-full text-sm font-bold tracking-widest uppercase">
                Limited Edition Drop
              </div>

              <div className="space-y-1">
                <h1 className="text-5xl md:text-7xl font-black text-white leading-none tracking-tight">
                  Kilted &amp;
                </h1>
                <h1 className="text-5xl md:text-7xl font-black leading-none tracking-tight text-transparent bg-clip-text bg-gradient-to-r from-amber-400 to-yellow-300">
                  Caffeinated
                </h1>
              </div>

              <div className="inline-flex items-center gap-3 border border-white/20 bg-white/5 px-4 py-2 rounded-lg">
                <span className="text-white/70 text-sm font-semibold uppercase tracking-wider">Not Beer.</span>
                <span className="text-white/40 text-xs">Because They Drank It All.</span>
              </div>

              <p className="text-xl md:text-2xl text-white/80 leading-relaxed max-w-xl">
                For the Tartan Army, Boston bars, and anyone who needs to be upright before tomorrow's match.
              </p>

              <p className="text-white/55 text-base leading-relaxed max-w-lg">
                Bond co-founder Chris Buchanan is of Scottish descent. When thousands of kilted fans hit Greater Boston ahead of Scotland vs. Morocco at Gillette, a family obligation kicked in. This is our contribution. Proudly a second beverage category.
              </p>

              <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start pt-2">
                <button
                  onClick={() => setShowOrderModal(true)}
                  className="group relative bg-gradient-to-r from-amber-500 to-yellow-400 text-[#0d1f3c] px-12 py-5 rounded-xl font-black text-xl transition-all duration-300 hover:from-amber-400 hover:to-yellow-300 shadow-2xl shadow-amber-500/40 hover:scale-105 transform inline-flex items-center justify-center gap-3 overflow-hidden"
                >
                  <div className="absolute inset-0 bg-gradient-to-r from-white/0 via-white/25 to-white/0 translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-1000" />
                  <Coffee className="w-6 h-6" />
                  Order Now
                </button>
                <a
                  href="#story"
                  className="bg-white/5 text-white border-2 border-white/20 px-10 py-5 rounded-xl font-semibold text-lg hover:bg-white/10 hover:border-amber-400/40 transition-all duration-300 inline-flex items-center justify-center gap-2"
                >
                  The Story
                  <ArrowRight className="w-5 h-5" />
                </a>
              </div>
            </div>

            {/* Right: bag image */}
            <div className="flex items-center justify-center relative order-1 lg:order-2">
              <div className="absolute inset-0 bg-gradient-to-br from-blue-700/25 to-amber-500/15 rounded-3xl blur-3xl scale-110" />
              <div className="relative">
                <div className="absolute -inset-4 bg-gradient-to-br from-amber-500/20 to-blue-700/20 rounded-3xl blur-xl" />
                <img
                  src="/ChatGPT_Image_Jun_18,_2026_at_01_37_06_PM.png"
                  alt="Kilted & Caffeinated Coffee"
                  className="relative w-full max-w-sm md:max-w-md rounded-2xl shadow-2xl transform hover:scale-105 transition-transform duration-500"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Press-release story */}
      <div id="story" className="max-w-4xl mx-auto px-6 py-20">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">The Story</h2>
          <div className="w-20 h-1 bg-amber-500 mx-auto rounded-full" />
        </div>

        <div className="bg-gradient-to-br from-blue-800/20 to-transparent border border-blue-600/25 rounded-2xl p-8 md:p-12 space-y-6 text-white/80 text-lg leading-relaxed">
          <p className="text-2xl font-bold text-white text-center mb-4">
            Scotland's traveling supporters nearly drank<br />
            <span className="text-amber-400">Boston dry.</span>
          </p>

          <p>
            When the headlines arrived — Tartan Army floods Boston, beer supply threatened, bagpipes heard from as far as Marblehead — Bond co-founder Chris Buchanan felt a pull. Not just civic pride. Family obligation. The man's last name is Buchanan. There's a tartan for that.
          </p>

          <p>
            "We saw the headlines and immediately thought: these people are going to need a second beverage category," said Chris. "Also, I'm of Scottish descent, so at a certain point I felt a family obligation to help out. Not instead of beer, obviously — we're not trying to start an international incident. Just before beer. Or after beer. Or during the brief morning window when beer feels ambitious."
          </p>

          <p>
            The result: <span className="font-semibold text-white">Kilted &amp; Caffeinated</span> — a limited-edition Bond Coffee drop dressed for the occasion, wearing a nod to Buchanan tartan, and stamped with a disclaimer that continues to be legally important: it is not beer.
          </p>

          <p className="text-xl font-semibold text-white/90 text-center italic">
            "Welcome to Boston. Good luck tomorrow. Please consider hydrating."
          </p>

          <p className="text-white/60 text-sm text-center mt-4">
            — Chris Buchanan, Bond Coffee Co-Founder & Person of Scottish Descent
          </p>
        </div>
      </div>

      {/* Coffee profile */}
      <div className="max-w-4xl mx-auto px-6 pb-20">
        <h2 className="text-3xl md:text-4xl font-bold text-white text-center mb-10">
          What's in the Bag
        </h2>
        <div className="bg-white/5 border border-white/10 rounded-2xl p-8 md:p-10 space-y-6">
          <p className="text-white/75 text-lg leading-relaxed text-center max-w-2xl mx-auto">
            Contains caffeine, local enthusiasm, and the kind of decision-making that happens when a coffee company sees a headline and says "we can make this weirder by lunchtime."
          </p>
          <div className="grid md:grid-cols-2 gap-4 pt-2">
            <div className="bg-white/5 border border-white/10 rounded-xl p-4">
              <h4 className="font-semibold text-white mb-1">Contains</h4>
              <p className="text-white/65">Caffeine. No alcohol. No hops. No official endorsement from any football governing body.</p>
            </div>
            <div className="bg-white/5 border border-white/10 rounded-xl p-4">
              <h4 className="font-semibold text-white mb-1">Availability</h4>
              <p className="text-white/65">Limited edition. While supplies last. This is a drop, not a dynasty.</p>
            </div>
            <div className="bg-white/5 border border-white/10 rounded-xl p-4">
              <h4 className="font-semibold text-white mb-1">Best Served</h4>
              <p className="text-white/65">Before beer. After beer. During the brief morning window when beer feels ambitious.</p>
            </div>
            <div className="bg-white/5 border border-white/10 rounded-xl p-4">
              <h4 className="font-semibold text-white mb-1">Size</h4>
              <p className="text-white/65">10 oz (283g)</p>
            </div>
          </div>
        </div>
      </div>

      {/* Who it's for */}
      <div className="max-w-5xl mx-auto px-6 pb-20">
        <div className="bg-gradient-to-br from-blue-800/20 to-transparent border border-blue-600/20 rounded-2xl p-8 md:p-12">
          <h2 className="text-3xl font-bold text-white text-center mb-8">
            Designed for Three Groups
          </h2>
          <div className="grid sm:grid-cols-3 gap-6 text-center">
            <div className="space-y-3">
              <div className="text-4xl">🏴󠁧󠁢󠁳󠁣󠁴󠁿</div>
              <h4 className="text-white font-bold">Scottish Supporters</h4>
              <p className="text-white/55 text-sm leading-relaxed">Preparing for another historic match. Possibly still singing.</p>
            </div>
            <div className="space-y-3">
              <div className="text-4xl">🍺</div>
              <h4 className="text-white font-bold">Boston Bartenders</h4>
              <p className="text-white/55 text-sm leading-relaxed">Currently in recovery mode. You've earned this.</p>
            </div>
            <div className="space-y-3">
              <div className="text-4xl">🎶</div>
              <h4 className="text-white font-bold">Local Residents</h4>
              <p className="text-white/55 text-sm leading-relaxed">Who have recently learned that bagpipes are not subject to volume control.</p>
            </div>
          </div>
        </div>
      </div>

      {/* Pricing & CTA */}
      <div className="max-w-2xl mx-auto px-6 pb-20">
        <div className="bg-gradient-to-br from-amber-500/15 to-transparent border-2 border-amber-500/40 rounded-2xl p-8 md:p-12 text-center">
          <h2 className="text-4xl font-bold text-white mb-1">Order Yours</h2>
          <p className="text-white/50 mb-6 text-sm">Limited edition · While supplies last</p>

          <div className="mb-8">
            <div className="inline-flex items-baseline gap-2">
              <span className="text-6xl font-black text-amber-400">$27</span>
              <span className="text-white/50 text-lg">/ 10 oz bag</span>
            </div>
            <p className="text-white/40 text-xs mt-1">Shipping included</p>
            <p className="text-amber-400/90 text-sm font-semibold mt-2">Ships starting June 25th</p>
          </div>

          <div className="bg-white/5 border border-white/10 rounded-xl p-5 mb-8 text-left space-y-2">
            <div className="flex items-center gap-3 text-white/75 text-sm">
              <Zap className="w-4 h-4 text-amber-400 shrink-0" />
              Contains caffeine — not beer
            </div>
            <div className="flex items-center gap-3 text-white/75 text-sm">
              <Zap className="w-4 h-4 text-amber-400 shrink-0" />
              Freshly roasted, ships US-wide
            </div>
            <div className="flex items-center gap-3 text-white/75 text-sm">
              <Zap className="w-4 h-4 text-amber-400 shrink-0" />
              Limited run — no promises on a restock
            </div>
            <div className="flex items-center gap-3 text-white/75 text-sm">
              <Zap className="w-4 h-4 text-amber-400 shrink-0" />
              Buchanan tartan approved
            </div>
          </div>

          <button
            onClick={() => setShowOrderModal(true)}
            className="group relative block w-full bg-gradient-to-r from-amber-500 to-yellow-400 text-[#0d1f3c] py-5 rounded-xl font-black text-xl transition-all duration-300 hover:from-amber-400 hover:to-yellow-300 shadow-2xl shadow-amber-500/30 hover:scale-[1.02] transform overflow-hidden mb-3"
          >
            <div className="absolute inset-0 bg-gradient-to-r from-white/0 via-white/25 to-white/0 translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-1000" />
            Order Kilted &amp; Caffeinated
          </button>

          <p className="text-white/35 text-xs">
            Questions? hello@bondcoffee.com
          </p>
        </div>
      </div>

      {/* Footer CTA */}
      <div className="border-t border-white/10 py-16">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <h3 className="text-3xl font-bold text-white mb-3">
            Come on Scotland. Good luck tomorrow.
          </h3>
          <p className="text-white/50 text-lg mb-8">
            We're rooting for you. And we made sure you have coffee.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button
              onClick={() => setShowOrderModal(true)}
              className="bg-gradient-to-r from-amber-500 to-yellow-400 text-[#0d1f3c] px-10 py-4 rounded-xl font-black text-lg hover:from-amber-400 hover:to-yellow-300 transition-all duration-300 inline-flex items-center justify-center gap-2 shadow-xl shadow-amber-500/30"
            >
              <Coffee className="w-5 h-5" />
              Order Now
            </button>
            <Link
              to="/"
              className="bg-white/10 text-white border border-white/20 px-8 py-4 rounded-xl font-semibold text-lg hover:bg-white/20 transition-all duration-300 inline-flex items-center justify-center"
            >
              Explore Bond Coffee
            </Link>
          </div>
        </div>
      </div>

      <Footer />

      {/* Order Modal */}
      {showOrderModal && (
        <div className="fixed inset-0 bg-black/80 backdrop-blur-sm z-50 flex items-center justify-center p-4 overflow-y-auto">
          <div className="bg-[#0d1f3c] border-2 border-amber-500/30 rounded-2xl max-w-xl w-full p-8 relative shadow-2xl my-8">
            <button
              onClick={() => setShowOrderModal(false)}
              className="absolute top-4 right-4 text-white/60 hover:text-white transition-colors bg-white/5 rounded-full p-1"
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>

            <div className="text-center mb-6">
              <img
                src="/ChatGPT_Image_Jun_18,_2026_at_01_37_06_PM.png"
                alt="Kilted & Caffeinated"
                className="w-32 mx-auto rounded-xl mb-4 shadow-xl"
              />
              <h2 className="text-2xl font-black text-white mb-1">Kilted &amp; Caffeinated</h2>
              <p className="text-amber-400/80 text-sm font-semibold">NOT BEER. Limited Edition.</p>
            </div>

            <div className="bg-white/5 border border-white/10 rounded-xl p-6 hover:border-amber-400/40 transition-all mb-4">
              <div className="flex items-center gap-4 mb-4">
                <Truck className="w-10 h-10 text-amber-400 shrink-0" />
                <div>
                  <h3 className="text-lg font-bold text-white">Ship Anywhere in the US</h3>
                  <p className="text-white/55 text-sm">Shipping included · 10 oz bag</p>
              <p className="text-amber-400/80 text-xs font-semibold mt-0.5">Ships starting June 25th</p>
                </div>
              </div>
              <div className="flex items-center justify-between mb-5">
                <span className="text-white/60 text-sm">Per bag</span>
                <span className="text-3xl font-black text-amber-400">$27</span>
              </div>
              <a
                href={STRIPE_LINK}
                target="_blank"
                rel="noopener noreferrer"
                className="block w-full bg-gradient-to-r from-amber-500 to-yellow-400 text-[#0d1f3c] py-4 rounded-xl font-black text-lg text-center hover:from-amber-400 hover:to-yellow-300 transition-all shadow-lg shadow-amber-500/20"
              >
                Order Now — $27
              </a>
            </div>

            <p className="text-white/30 text-xs text-center mt-3">
              Secure checkout via Stripe · Questions? hello@bondcoffee.com
            </p>
          </div>
        </div>
      )}
    </div>
  );
}
